import axios from 'axios';

// set the baseURL so it is included automatically
export default axios.create({
  baseURL: process.env.ApiUrl,
});



// WEBPACK FOOTER //
// ./src/api.js